import { render, staticRenderFns } from "./comment-warning.vue?vue&type=template&id=dfeaf4a6&scoped=true&"
import script from "./comment-warning.vue?vue&type=script&lang=js&"
export * from "./comment-warning.vue?vue&type=script&lang=js&"
import style0 from "./comment-warning.vue?vue&type=style&index=0&id=dfeaf4a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfeaf4a6",
  null
  
)

export default component.exports